import styled from 'styled-components';

export const StyledAddUserActivity = styled.div`
  box-sizing: border-box;
  width: 670px;
  padding: 48px;
`;

export const AddUserActivityTitle = styled.div`
  font-weight: 600;
  font-size: 24px;
  color: #444;
`;

export const AddUserActivityBody = styled.div`
  margin: 24px 0;
`;

export const AddUserActivityFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;

  > * {
    margin-left: 24px;
    min-width: 160px;
  }
`;

export const AddUserActivityFormRow = styled.div`
  margin: 24px 0;
  display: flex;
  flex-direction: column;
`;

export const AddUserActivityLabel = styled.label`
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 16px;
  color: #444;
`;

export const AddUserActivityHelperText = styled.div`
  text-align: right;
  font-size: 16px;
  color: #444;
  margin: 12px 0;
`;
